import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-po',
  templateUrl: './about-po.component.html',
  styleUrls: ['./about-po.component.css']
})
export class AboutPoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
